// extracted by extract-css-chunks-webpack-plugin
module.exports = {"_sharedGrid":"startPage___sharedGrid--197he","startPage":"startPage__startPage--2_wUL","startPageContent":"startPage__startPageContent--10gQg"};